// created by LinWeiLong @ 2017/06/21

import axios from 'axios';
import APIS from '../../apis';
import qs from 'qs';
import { callbackHandler } from '../callbackHandler';

export default {
    state: {
        INDEXSCROLLTOP: 0,
        advertisingConfig: null,
        advertisingPlatform: {},
        isConsult525: false, // 是否是2021-525咨询
        endTime525: 0, // 2021-525结束时间
        notCompleteCount: {}, // 未完成的测评和咨询数量
        weappUrlScheme: '', // 投放跳转的小程序url scheme
    },
    mutations: {
        setINDEXSCROLLTOP(state, number) {
            state.INDEXSCROLLTOP = number;
        },
        setAdvertisingConfig(state, val) {
            state.advertisingConfig = val
        },
        setAdvertisingPlatform(state, val) {
            state.advertisingPlatform = val
        },
        setIsConsult525(state, val) {
            state.isConsult525 = val
        },
        setEndTime525(state, val) {
            state.endTime525 = val
        },
        setNotCompleteCount(state, val) {
            state.notCompleteCount = val
        },
        setWeappUrlScheme(state, val) {
            state.weappUrlScheme = val
        }
    },
    getters: {
        advertisingConfig: state => state.advertisingConfig,
        advertisingPlatform: state => state.advertisingPlatform,
        isConsult525: state => state.isConsult525,
        endTime525: state => state.endTime525,
        notCompleteCount: state => state.notCompleteCount,
        weappUrlScheme: state => state.weappUrlScheme
    },
    actions: {
        // 测评Banner
        pullHomePageBanner(context, params) {
            axios.get(APIS.homePageBanner, {
                params: params.params
            }).then(function(res) {
                callbackHandler(APIS.homePageBanner, res, params.callback);
            })
        },
        // 测评Hot列表
        pullHotScales(context, params) {
            axios.get(APIS.getHotScales, {
                params: params.params
            }).then((res) => {
                callbackHandler(APIS.getHotScales, res, params.callback);
            })
        },
        // 测评New列表
        pullNewScales(context, params) {
            axios.get(APIS.getNewScales, {
                params: params.params
            }).then((res) => {
                callbackHandler(APIS.getNewScales, res, params.callback);
            })
        },
        // 精选测评
        pullChoiceScales(context, params) {
            axios.get(APIS.getHandpickScales, {
                params: params.params
            }).then((res) => {
                callbackHandler(APIS.getHandpickScales, res, params.callback);
            })
        },
        // 测评列表
        pullScales(context, params) {
            axios.get(APIS.getScales, {
                params: params.params
            }).then(function(res) {
                callbackHandler(APIS.getScales, res, params.callback);

            })
        },
        // 测评详情
        GET_SCALE_DETAIL(context, params) {
            return axios.get(APIS.getScaleDetail, {
                params: params.params
            }).then(function(res) {
                callbackHandler(APIS.getScaleDetail, res);
                return res.data;
            })
        },
        getNologinScaleDetail(context, params) {
            return axios.get(APIS.getNologinScaleDetail, {
                params: params.params
            }).then(function(res) {
                callbackHandler(APIS.getNologinScaleDetail, res);
                return res.data;
            })
        },
        getAdvertisingCepingConfig(context, params) {
            return axios.get(APIS.getAdvertisingCepingConfig, {
                params: params.params
            }).then(function(res) {
                callbackHandler(APIS.getAdvertisingCepingConfig, res);
                return res.data;
            })
        },
        fetchAdvertisingPlatform(context, params) {
            return axios.get(APIS.fetchAdvertisingPlatform, {
                params: params.params
            }).then(function(res) {
                callbackHandler(APIS.fetchAdvertisingPlatform, res);
                return res.data;
            })
        },
        getMiniappScheme(context, params) {
            return axios.get(APIS.miniappScheme, {
                params: params.params
            }).then(function(res) {
                callbackHandler(APIS.miniappScheme, res);
                return res.data;
            })
        },
        // H5测评详情
        pullH5Detail(context, params) {
            console.log(params)
            axios.get(APIS.h5Detail, {
                params: params.params
            }).then(function(res) {
                callbackHandler(APIS.getScaleDetail, res, params.callback);
            })
        },

        // 详情页 - 相关测试
        pullDetailRecomend(context, params) {
            axios.get(APIS.getRelevantScales, {
                params: params.params
            }).then(function(res) {
                callbackHandler(APIS.getRelevantScales, res, params.callback);

            })
        },
        // 购买测评, 套餐
        BUY_SCALE(context, { API, params }) {
            /*
             params 需要4各参数
             1、channelId
             2、scalePoolId
             3、tradeType
             4、goonBuy  存在已购买未完成的测评时 1表示继续购买
             */
            return axios.get(API, {
                params
            }).then(function(res) {
                callbackHandler(APIS.buyScale, res);
                return res.data;
            })
        },
        // 先做题后支付看报告的做题接口
        [`BUY_DOFIRST_TEST`]: function(context, { params, callback }) {
            return axios.get(APIS.doFirst, {
                params
            }).then((res) => {
                callbackHandler(APIS.doFirst, res, callback);
            })
        },
        // 获取套餐详情
        pullComboDetail(context, params) {
            /**
             * params 需要2个参数
             * 1、channelId
             * 2、comboId
             */
            axios.get(APIS.getComboDetail, {
                params: params.params
            }).then(function(res) {
                callbackHandler(APIS.buyScale, res, params.callback);
            })
        },
        // 获取我的测评列表
        pullMineScales(context, params) {
            axios.get(APIS.getMyData, {
                params: params.params
            }).then(function(res) {
                callbackHandler(APIS.getMyData, res, params.callback);
            })
        },
        // 购买趣味测试
        buyFunScale(context, params) {
            /**
             * params 有3各参数
             * channelId 渠道Id
             * orderId
             * scalePoolId 测评ID
             */
            axios.get(APIS.buyFunScale, {
                params: params.params,
            }).then(function(res) {
                callbackHandler(APIS.buyFunScale, res, params.callback);
            })
        },
        // 查询订单状态的方法
        checkOrderStatus(context, params) {
            /**
             * params
             * orderId Number
             */
            return axios.get(APIS.searchOrder, {
                params: params.params
            }).then(function(res) {
                callbackHandler(APIS.searchOrder, res, params.callback);
            })
        },

        // 购买完套餐获取套餐列表 和 报告页获取套餐的其他测评
        [`GET_COMBO_LIST`]: function(context, params) {
            axios.get(APIS.getComboList, {
                params: params.params
            }).then(res => {
                callbackHandler(APIS.homePageBanner, res, params.callback);
            })
        },

        [`DOFIRST_BUYREPORT`]: function(context, params) {
            return axios.get(APIS.stopSignInAndBuy, {
                params: params.params,
            }).then(res => {
                callbackHandler(APIS.homePageBanner, res, params.callback);
            })
        },
        // 详情页 - 收藏 取消收藏接口
        SetCollectScale(context, params) {
            return axios.get(APIS.collectScale, {
                params: params.params
            }).then(function(res) {
                callbackHandler(APIS.collectScale, res, params.callback);
                return res;
            })
        },
        // 我的测评--收藏列表接口
        getCollectScaleData(context, params) {
            axios.get(APIS.getCollectScaleData, {
                params: params.params
            }).then(function(res) {
                callbackHandler(APIS.getCollectScaleData, res, params.callback);
            })
        },
        // 我的测评--足迹列表接口
        getTrackScaleData(context, params) {
            axios.get(APIS.getTrackScaleData, {
                params: params.params
            }).then(function(res) {
                callbackHandler(APIS.getTrackScaleData, res, params.callback);
            })
        },
        // 我的测评--删除足迹列表接口
        delTrackScale(context, { env, params, callback } = {}) {
            axios.post(APIS.delTrackScale,
                qs.stringify(params)
            ).then(function(res) {
                console.log(res)
                callbackHandler(APIS.delTrackScale, res, callback, true);
                return res;
            })
        },
        // 心声页--获取自定义分享配置
        getCustomConfig(context, params) {
            axios.get(APIS.getCustomConfig, {
                params: params.params
            }).then(function(res) {
                console.log(res)
                callbackHandler(APIS.getCustomConfig, res, params.callback);
                return res;
            })
        },
        // 心声页--获取自定义分享配置
        getResultVoiceArr(context, params) {
            axios.get(APIS.getResultVoiceArr, {
                params: params.params
            }).then(function(res) {
                console.log(res)
                callbackHandler(APIS.getResultVoiceArr, res, params.callback);
                return res;
            })
        },
        // 心声页--获取长链接转短链接
        longToShort(context, { env, params, callback } = {}) {
            axios.post(APIS.longToShort,
                qs.stringify(params)
            ).then(function(res) {
                console.log(res)
                callbackHandler(APIS.longToShort, res, callback, true);
                return res;
            })
        },
        // 心声页--二维码短连接转长链接
        shortToLong(context, params) {
            axios.get(APIS.shortToLong, {
                params: params.params
            }).then(function(res) {
                console.log(res)
                callbackHandler(APIS.shortToLong, res, params.callback);
                return res;
            })
        },
        shareAuth(context, params) {
            return axios.get(APIS.shareAuth, {
                params: params.params
            }).then(function(res) {
                callbackHandler(APIS.shareAuth, res);
                return res.data;
            })
        },

        // 双十一活动促销--获取礼包列表
        packageList(context, params) {
            axios.get(APIS.packageList, {
                params: params.params
            }).then(function(res) {
                callbackHandler(APIS.packageList, res, params.callback);
            })
        },
        // 双十一活动促销--获取我的礼包
        getMyPackageOrderList(context, params) {
            axios.get(APIS.getMyPackageOrderList, {
                params: params.params
            }).then(function(res) {
                callbackHandler(APIS.getMyPackageOrderList, res, params.callback);
            })
        },
        // 双十一活动促销--购买优惠券
        BUY_COUPONS(context, { API, params }) {
            return axios.get(API, {
                params
            }).then(function(res) {
                callbackHandler(APIS.packageBuy, res);
                return res.data;
            })
        },
        // 双十一活动促销--购买礼包
        packageBuy(context, params) {
            axios.get(APIS.packageBuy, {
                params: params.params
            }).then(function(res) {
                callbackHandler(APIS.packageBuy, res, params.callback);
                return res;
            })
        },

        // 双十一活动促销--定金礼包的展示
        showExtrance(context, params) {
            axios.get(APIS.showExtrance, {
                params: params.params
            }).then(function(res) {
                callbackHandler(APIS.showExtrance, res, params.callback);
            })
        },
        // 双十一活动促销--定金礼包的展示
        showDeposit(context, params) {
            axios.get(APIS.showDeposit, {
                params: params.params
            }).then(function(res) {
                callbackHandler(APIS.showDeposit, res, params.callback);
            })
        },
        // 双十一活动促销--我的礼包的展示
        getDepositOrder(context, params) {
            return axios.get(APIS.getDepositOrder, {
                params: params.params
            }).then(function(res) {
                callbackHandler(APIS.getDepositOrder, res);
                console.log(res.data);
                return res.data;
            })
        },
        // 我的优惠券页面--获取个人中心优惠券列表（未使用、已使用、已失效）、下单购买页面优惠券列表
        userCouponList(context, params) {
            return axios.get(APIS.userCouponList, {
                params: params.params
            }).then(function(res) {
                callbackHandler(APIS.userCouponList, res);
                return res.data;
            })
        },
        // 我的优惠券页面--单击共享券赠送按钮获取优惠券的详情
        getCustomCoupon(context, params) {
            axios.get(APIS.getCustomCoupon, {
                params: params.params
            }).then(function(res) {
                callbackHandler(APIS.getCustomCoupon, res, params.callback);
            })
        },
        // 我的优惠券页面--单击共享券赠送按钮获取优惠券的详情
        couponGiftReceive(context, params) {
            return axios.get(APIS.couponGiftReceive, {
                params: params.params
            }).then(function(res) {
                callbackHandler(APIS.couponGiftReceive, res);
                return res.data;
            })
        },
        // 双十一分销
        getDistributionCard(context, params) {
            return axios.get(APIS.getDistributionCard, {
                params: params.params
            }).then(function(res) {
                callbackHandler(APIS.getDistributionCard, res);
                return res.data;
            })
        },
        // 双十一分销 我
        getMyReward(context, params) {
            console.log(params);
            return axios.get(APIS.getMyReward, {
                params: params.params
            }).then(function(res) {
                callbackHandler(APIS.getMyReward, res);
                return res.data;
            })
        },
        // 双十一分销 我的
        countMyCoupon(context, params) {
            console.log(params);
            return axios.get(APIS.countMyCoupon, {
                params: params.params
            }).then(function(res) {
                callbackHandler(APIS.countMyCoupon, res);
                return res.data;
            })
        },
        //我的优惠券兑换单品券
        REDEEMCODEUSE(context, params) {
            console.log(params);
            return axios.get(APIS.redeemCodeUse, {
                params: params.params
            }).then(function(res) {
                callbackHandler(APIS.redeemCodeUse, res);
                return res.data;
            })
        },
        //双十二活动
        //我的优惠券兑换单品券
        getDoubleTwelveScales(context, params) {
            return axios.get(APIS.getDoubleTwelveScales, {
                params: params.params
            }).then(function(res) {
                callbackHandler(APIS.getDoubleTwelveScales, res);
                return res.data;
            })
        },
        //双十二活动优惠券领取资格
        couponDoubleTwelveStatus(context, params) {
            return axios.get(APIS.couponDoubleTwelveStatus, {
                params: params.params
            }).then(function(res) {
                callbackHandler(APIS.couponDoubleTwelveStatus, res);
                return res.data;
            })
        },
        //领取自定义优惠券
        doubleTwelveScalesReceive(context, params) {
            return axios.get(APIS.doubleTwelveScalesReceive, {
                params: params.params
            }).then(function(res) {
                callbackHandler(APIS.doubleTwelveScalesReceive, res);
                return res.data;
            })
        },
        //下单购买页面优惠券列表
        scalePoolCouponList(context, params) {
            console.log(params);
            return axios.get(APIS.scalePoolCouponList, {
                params: params.params
            }).then(function(res) {
                callbackHandler(APIS.scalePoolCouponList, res);
                return res.data;
            })
        },
        //双十二活动入口展示、弹窗
        newUserVerify(context, params) {
            console.log(params);
            return axios.get(APIS.newUserVerify, {
                params: params.params
            }).then(function(res) {
                callbackHandler(APIS.newUserVerify, res);
                return res.data;
            })
        },
        //限时折扣优惠券弹窗状态资格
        GET_DISCOUNT_COUPON_STATUS(context, params) {
            return axios.get(APIS.getDiscountCouponStatus, {
                params: params.params
            }).then(function(res) {
                callbackHandler(APIS.getDiscountCouponStatus, res);
                return res.data;
            })
        },
        //限时折扣优惠券领取
        DISCOUNT_COUPON_RECERIVE(context, params) {
            return axios.get(APIS.discountCouponReceive, {
                params: params.params
            }).then(function(res) {
                callbackHandler(APIS.discountCouponReceive, res);
                return res.data;
            })
        },
        //获取用户奥斯卡卡片记录的接口
        GETUSEROSCARACTCARD(context, params) {
            console.log(params);
            return axios.get(APIS.getUserOscarActCard, {
                params: params.params
            }).then(function(res) {
                callbackHandler(APIS.getUserOscarActCard, res);
                return res.data;
            })
        },
        setTop20PushRelation(context, params) {
            console.log(params);
            return axios.get(APIS.setTop20PushRelation, {
                params: params.params
            }).then(function(res) {
                callbackHandler(APIS.setTop20PushRelation, res);
                return res.data;
            })
        },
        storeSource(context, params) {
            console.log('进入接口---')
            console.log(params)
            return axios.get(APIS.storeSource, {
                params: params.params
            }).then(function(res) {
                callbackHandler(APIS.storeSource, res);
                return res.data;
            })
        },
        bindGenesis(context, params) {
            console.log('盘古登录---')
            console.log(params)
            return axios.get(APIS.bindGenesis, {
                params: params.params
            }).then(function(res) {
                callbackHandler(APIS.bindGenesis, res);
                return res.data;
            })
        },
        // 详情页 下单10s后查询支付情况 显示优惠券
        newUserCouponReceive(context, { API, params }) {
            return axios.get(API, {
                params: params
            }).then(function(res) {
                callbackHandler(API, res);
                return res.data;
            })
        },
        // 未登录个人中心页-查询订单
        noLoginSearchOrder(context, params) {
            return axios.get(APIS.noLoginSearchOrder, {
                params: params.params
            }).then(function(res) {
                callbackHandler(APIS.noLoginSearchOrder, res);
                return res;
            })
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/show.js